import { SALESFORCE_APP_INSTALL_KEY } from '@/constants/storageKeys';

export type SalesforceAppInstallType = {
  installUrl: string;
  integrationType: string;
  settingsUsecase: string;
  isSandbox: boolean;
  attempts: number;
};

export function saveSalesforceAppInstall(
  install: Omit<SalesforceAppInstallType, 'attempts'>,
) {
  const previous = readSalesforceAppInstall();
  sessionStorage.setItem(
    SALESFORCE_APP_INSTALL_KEY,
    JSON.stringify({ ...install, attempts: (previous?.attempts ?? 0) + 1 }),
  );
}

export function readSalesforceAppInstall(): SalesforceAppInstallType | null {
  const stored = sessionStorage.getItem(SALESFORCE_APP_INSTALL_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch (err) {
    return null;
  }
}

export function clearSalesforceAppInstall() {
  sessionStorage.removeItem(SALESFORCE_APP_INSTALL_KEY);
}
